import { addDays, addYears, endOfYear, isAfter, startOfDay } from 'date-fns';

/** Last calendar day on which any day of the event may fall (Dec 31 of the year after `referenceDate`). */
export function getMaxEventPlanCalendarEnd(referenceDate: Date = new Date()) {
  return endOfYear(addYears(referenceDate, 1));
}

/** Latest allowed first day of the event so that all days fall on or before `getMaxEventPlanCalendarEnd`. */
export function getLatestAllowedEventStartDate(durationDays: number, referenceDate: Date = new Date()) {
  const maxEnd = getMaxEventPlanCalendarEnd(referenceDate);
  return addDays(maxEnd, -(durationDays - 1));
}

export function isEventStartAndDurationWithinPlanWindow(
  startDate: Date,
  durationDays: number,
  referenceDate: Date = new Date(),
) {
  const maxEnd = getMaxEventPlanCalendarEnd(referenceDate);
  const lastEventDay = addDays(startOfDay(startDate), durationDays - 1);
  return !isAfter(lastEventDay, maxEnd);
}
